module.exports = __webpack_public_path__ + "static/img/map_none.f3b2310.png";


//////////////////
// WEBPACK FOOTER
// ./src/static_dazzle/images/map_none.png
// module id = m/YI
// module chunks = 1